import HeaderModal from "../../headers/header_modal";
import {Container, Content, ContentExplication, TextExplication} from "./styled";
import React, {useState} from "react";
import {
    ModalTransferTicketProps
} from "@dropDesk/presentation/components/modals/modal_transfer_ticket/modal_transfer_ticket";
import {UserRole} from "@dropDesk/domain/entities/user/user_enum";
import {UserEntity} from "@dropDesk/domain/entities/user/user.entity";
import {SectorEntity} from "@dropDesk/domain/entities/sector/sector.entity";
import {
    ContentDataInput,
    ContentInput
} from "@dropDesk/presentation/pages/client/ui/my_clients/form/inputs_clients/styled";
import {Tooltip} from "antd";
import InputTextAreaWithBorder from "@dropDesk/presentation/components/inputs/input_textarea_with_border";
import {TicketMessageEntity} from "@dropDesk/domain/entities/ticket/message/ticket_message.entity";
import FooterModal from "@dropDesk/presentation/components/footer/footer_modal";
import {useInjection} from "inversify-react";
import {AppController} from "@dropDesk/presentation/app/app.controller";
import ModalMain from "@dropDesk/presentation/components/modals/modal_main";
import {newMessage} from "@dropDesk/presentation/pages/chat/controller/new_message";
import {TextMessageEntity} from "@dropDesk/domain/entities/ticket/message/external/message_entity";
import {ICONS_DROPDESK} from "@dropDesk/storage/icons/icons.d";
import SelectSearchSector from "@dropDesk/presentation/components/inputs/select_search_sectors";
import SelectSearchUser from "@dropDesk/presentation/components/inputs/select_search_users";


export default function ModalTransferTicket(props: ModalTransferTicketProps) {
    const initialStateMessage: TicketMessageEntity = newMessage(props.idTicket);
    const [user, setUser] = useState<UserEntity | undefined>(undefined);
    const [sector, setSector] = useState<SectorEntity | undefined>(undefined);
    const [message, setMessage] = useState<TicketMessageEntity>(initialStateMessage);

    const appController = useInjection(AppController);
    const colors = appController.theme.colorScheme;

    return (
        <ModalMain
            open={props.visible}
            onRequestClose={props.onClose}
            width={470}
            renderComponent={
                <Container background={colors.onBackground}>
                    <HeaderModal
                        disabled={props.loading}
                        letter={"Transferir Atendimento"}
                        nameIcon={ICONS_DROPDESK.close}
                        onClick={props.onClose}
                    />
                    <Content>
                        <ContentExplication>
                            <TextExplication color={colors.text}>
                                Atenção: ao transferir sem selecionar um atendente, o atendimento ficará em aberto no setor. Se selecionar um atendente, ele será direcionado diretamente para ele.
                            </TextExplication>

                        </ContentExplication>

                        <ContentDataInput>
                            <ContentInput style={{marginRight: 20}}>
                                <SelectSearchSector
                                    required={true}
                                    size={37}
                                    useRemoveFilter={false}
                                    label={'Setor'}
                                    placeHolder={"Selecione o setor"}
                                    messageError={!sector ? "Selecione o Setor" : ""}
                                    idUser={props.listBySectorsByUserLinkedInTransferTicket}
                                    handleSelectSector={(value, sector) => {
                                        if (sector) {
                                            setSector(sector);
                                        }
                                    }}
                                    value={sector ? {
                                        value: sector.id,
                                        label: sector?.realName(appController.user!) ?? ''
                                    } : undefined}
                                    disabled={props.loading}

                                />
                            </ContentInput>
                            <Tooltip title={!sector ? "Selecione um setor para poder selecionar um atendente." : ""}>
                                <ContentInput style={{marginBottom: 25}}>
                                    <SelectSearchUser
                                        size={37}
                                        useRemoveFilter={!!user}
                                        label={"Atendente"}
                                        placeHolder={"Opcional"}
                                        handleSelectUser={(value, user) => {
                                            if (user) {
                                                setUser(user)
                                            } else {
                                                setUser(undefined)
                                            }
                                        }}
                                        value={user ? {value: user.id, label: user.name} : undefined}
                                        role={UserRole.attendant}
                                        idSector={sector?.id}
                                        disabled={props.loading || !sector}
                                    />
                                </ContentInput>
                            </Tooltip>
                        </ContentDataInput>
                        <ContentDataInput>
                            <ContentInput>
                                <InputTextAreaWithBorder
                                    required={false}
                                    marginTop={5}
                                    name='description'
                                    size={65}
                                    disabled={props.loading}
                                    placeHolder={"Comentário visível apenas para a equipe de atendimento."}
                                    label={"Comentário interno"}
                                    value={message.getText}
                                    onChange={(event) => {

                                        const value = new TextMessageEntity({
                                            conversation: event.target.value
                                        });
                                        setMessage(message.copyWith({
                                            textMessage: value,
                                            isPrivate: true
                                        }))
                                    }}
                                />
                            </ContentInput>
                        </ContentDataInput>
                    </Content>
                    <FooterModal
                        disabled={props.loading || !sector}
                        loading={props.loading}
                        type={"submit"}
                        letter={'Confirmar'}
                        onSubmit={() => {
                            if (sector) {
                                props.onTransfer(sector, user, message)
                            }
                        }}
                        onRequestClose={props.onClose}
                    />
                </Container>
            }
        />
    );
}
